import PublicationEdit from "./PublicationEdit";
import PublicationSuccess from "./PublicationSuccess";

export const editPet = [
    {
        title: 'Проверьте правильность введенных данных',
        progress: { title: 'Проверка введенных данных', step: 2 },
        component: PublicationEdit, valid: true, required: true,
    },
    {
        progress: { title: 'Спасибо', step: 3 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default editPet;
